import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  contentItemRequest,
  contentItemSuccess,
  contentItemFailure,
} from '../reducers/contentList';
import { authUserFailure } from '../reducers/login';
import { API_LINK } from '../../constants';
import {selectedProgram, selectedProgramId, selectedContentId, selectedContent, selectedVersionId, getSelectedThinktool} from '../selectors'
import { modulesListRequest } from '../reducers/modulesList';
import { setExtensions } from '../reducers/userProgramsFull';

const API = `${API_LINK}api/user`;

function* contentItemAxios() {
  const state = yield select(fullState => fullState);
  const { selectedProgramId, selectedContentId, assessmentContent } = state.userProgramsFullReducer;
  const {   user: { userId },
  token } = state.loginReducer;

  if(selectedContentId==null && (assessmentContent.survey_exam==true || assessmentContent.survey_supplementary ==true)){
    const response2 = yield call(() =>
    axios({
      method: 'get',
      url: `${API}/${userId}/getComponent?component_id=${assessmentContent.contentId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );
  return response2;
  }else{
    const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}/${userId}/getComponent?component_id=${selectedContentId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );
  return response;
  }
  

  
}
function* contentExamAxios() {
  const state = yield select(fullState => fullState);
  const { selectedProgramId, selectedContentId, assessmentContent } = state.userProgramsFullReducer;
  const {   user: { userId },
  token } = state.loginReducer;
  if(selectedContentId==null && (assessmentContent.survey_exam==true || assessmentContent.survey_supplementary ==true)){
    const response3 = yield call(() =>
    axios({
      method: 'get',
      url: `${API}/${userId}/getComponent?component_id=${assessmentContent.connected_exam}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );
  return response3;
  }

  

  
}
function* workerContentItemSaga() {
  try {
   
    const response = yield call(contentItemAxios);
   
    const responseFromcontentItem = response.data;
    
    yield put(contentItemSuccess(responseFromcontentItem.data.component[0].content[0]));
    yield put(modulesListRequest());
    if(responseFromcontentItem.data.component[0].content[0].type=='Assignments' || responseFromcontentItem.data.component[0].content[0].type=='WSR Assessments'){
      yield put(setExtensions(responseFromcontentItem.data.component[0].content[0].extensions_left))
    }
  } catch (error) {
    yield put(contentItemFailure(error.response));
  }
  try {
    const response2= yield call(contentExamAxios);
    const responseFromcontentItem2 = response2.data;
    
    yield put(contentItemSuccess(responseFromcontentItem2.data.component[0].content[0]));
    if(responseFromcontentItem2.data.component[0].content[0].type=='Assignments' || responseFromcontentItem2.data.component[0].content[0].type=='WSR Assessments'){
      yield put(setExtensions(responseFromcontentItem2.data.component[0].content[0].extensions_left))
    }
    yield put(modulesListRequest())
    if (response2.status === 500) {
      yield put(authUserFailure(response2));
    }
  } catch (error) {
    yield put(contentItemFailure(error.response));
  }
    
 
}

export function* watcherContentItemSaga() {
  yield takeLatest(contentItemRequest().type, workerContentItemSaga);
}
